type CacheKey = Array<object | string | number | boolean | []>;

export type CacheName = string;
export type CacheId = [CacheName, ...CacheKey];

const cache = {};

export function useCache<ValueType>() {
  function generateHash(cacheId: CacheId) {
    return JSON.stringify(cacheId);
  }

  function setCache(cacheId: CacheId, value: ValueType): void {
    const [name] = cacheId;
    const hash = generateHash(cacheId);

    cache[name] = cache[name] ?? {};
    cache[name][hash] = value;
  }

  function clearCache(cacheName: CacheName): void {
    delete cache[cacheName];
  }

  function getCached(cacheId: CacheId) {
    const [name] = cacheId;
    const hash = generateHash(cacheId);

    return cache[name]?.[hash] as ValueType | undefined;
  }

  return {
    setCache,
    getCached,
    clearCache,
  };
}
